module.exports = __webpack_public_path__ + "static/media/modbus-box.194f3f0a.jpg";